var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: "cost-unit-draft-edit-modal",
        "hide-footer": "",
        "no-close-on-backdrop": "",
        size: "xl",
        title: "Schadenpositionsentwurf bearbeiten",
        visible: _vm.isModalOpen,
      },
      on: {
        hide: function ($event) {
          return _vm.hideReset()
        },
        show: _vm.loadForm,
      },
    },
    [
      _c(
        "csp-desktop-info-card",
        {
          ref: "costUnitDraftInfoCard",
          staticClass: "record-cost-unit-edit-modal",
          attrs: {
            cols: 12,
            "form-context": _vm.formContext,
            icon: "inticon-users",
            title: "Kunde",
          },
          on: { "cancel-form": _vm.reset, save: _vm.saveCostUnitDraftFormData },
        },
        [
          _c("csp-record-detail-cost-unit-basedata", {
            attrs: {
              "form-context": _vm.formContext,
              "hide-for-group-options": _vm.hideForGroupOptions,
              "record-id": _vm.recordId,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }